import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  variant?: 'default' | 'error';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ variant = 'default', size = 'md', fullWidth = true, className = '', ...props }, ref) => {
    const baseClasses = 'border rounded-lg oro-transition focus:oro-focus hover:border-border-hover';
    
    const variantClasses = {
      default: 'border-border bg-surface-alt text-text-primary placeholder:text-text-muted focus:border-accent/60',
      error: 'border-red-500/60 bg-red-500/5 text-red-200 placeholder:text-red-300 focus:border-red-400'
    };

    const sizeClasses = {
      sm: 'px-3 py-1.5 text-sm',
      md: 'px-4 py-2 text-sm',
      lg: 'px-4 py-3 text-base'
    };

    const widthClass = fullWidth ? 'w-full' : '';

    const classes = `
      ${baseClasses} 
      ${variantClasses[variant]} 
      ${sizeClasses[size]} 
      ${widthClass}
      ${className}
    `.trim();

    return (
      <input
        ref={ref}
        className={classes}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

export default Input;